import { getFocusRingBorderCSS } from '@ardoq/style-helpers';
import { NodeViewWrapper, type NodeViewProps } from '@tiptap/react';
import styled, { css } from 'styled-components';
import {
  FALLBACK_IMAGE_SIZE_PRESET,
  IMAGE_SIZE_PRESET_WIDTHS,
  isImageSizePreset,
} from './imageSizing';

const StyledImage = styled.img<{ $isSelected?: boolean }>`
  display: block;
  max-width: 100%;
  height: auto;
  ${({ $isSelected }) =>
    $isSelected &&
    css`
      ${getFocusRingBorderCSS()};
    `};
`;

export const ImageViewBlock: React.FC<NodeViewProps> = ({ node, selected }) => {
  const { src, alt, size } = node.attrs;
  const preset = isImageSizePreset(size) ? size : FALLBACK_IMAGE_SIZE_PRESET;
  return (
    <NodeViewWrapper
      data-drag-handle
      as="span"
      // The preset width belongs on the wrapper: it is `width: fit-content`, so
      // a percentage on the image would resolve against the image's own width
      // rather than the surrounding text column. NodeViewWrapper cannot be
      // wrapped in styled() without breaking Tiptap's node view detection.
      style={{
        display: 'inline-block',
        maxWidth: IMAGE_SIZE_PRESET_WIDTHS[preset],
      }}
    >
      <StyledImage src={src} alt={alt ?? ''} $isSelected={selected} />
    </NodeViewWrapper>
  );
};
